const React = require('react');
const shallowCompare = require('react-addons-shallow-compare');

const ActiveSelect = React.createClass({
  displayName: 'ActiveSelect',
  propTypes: {
    optionsData: React.PropTypes.array.isRequired,
    isPrivateRoom: React.PropTypes.bool,
    optionComponent: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]).isRequired,
    onSelectOption: React.PropTypes.func.isRequired,
    className: React.PropTypes.string,
    needAmount: React.PropTypes.number,
    dishes: React.PropTypes.array,
    serviceProps: React.PropTypes.object,
    commercialProps: React.PropTypes.object,
    fromWholeOrderBenefit: React.PropTypes.bool,
    extTitle: React.PropTypes.string,
    sendSubComponentParam: React.PropTypes.object,
    isHDL: React.PropTypes.bool,
    showDelivery: React.PropTypes.bool,
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  onSelectOption(evt, wholeBenefitData) {
    evt.preventDefault();
    const { optionsData } = this.props;
    const { id } = evt.currentTarget.dataset;
    if (wholeBenefitData) {
      this.props.onSelectOption(evt, wholeBenefitData);
      return;
    }
    const optionData = optionsData.find(item => {
      if (isNaN(id).toString()) {
        return String(item.id) === String(id);
      }
      return false;
    });
    this.props.onSelectOption(evt, optionData);
  },
  renderOptions(params) {
    const { fromWholeOrderBenefit, extTitle, sendSubComponentParam } = this.props;
    const subComponentParam = sendSubComponentParam || {};
    return (params.optionsData || []).map(optionData => {
      let { label, oldPrice, newPrice } = optionData;
      // 如果showDelivery=true则需要展示新旧配送费
      // 新旧价格相等则-展示新价格
      // 新旧价格不等-且新的价格存在和等于0-展示新价格
      if (params.showDelivery) {
        label = (
          <div>
            {oldPrice != newPrice && <span className={newPrice || newPrice == 0 ? 'delivery-oldPrice' : ''}>￥{oldPrice}</span>}
            &nbsp;
            {(newPrice || newPrice == 0) && <span className="delivery-newPrice">￥{newPrice}</span>}
          </div>
        );
      }
      return React.createElement(
        params.optionComponent,
        Object.assign(
          {},
          {
            key: optionData.id,
            isPrivateRoom: params.isPrivateRoom,
            needAmount: params.needAmount,
            'data-option': '',
            'data-id': optionData.id,
            onTouchTap: this.onSelectOption,
            dishes: params.dishes,
            serviceProps: params.serviceProps,
            dishNames: optionData.dishNames,
            extTitle,
            isHDL: params.isHDL,
          },
          fromWholeOrderBenefit ? { commercialProps: params.commercialProps, showWholeBenefitRange: params.showWholeBenefitRange } : {},
          optionData,
          subComponentParam,
        ),
        label,
      );
    });
  },
  render() {
    const { className } = this.props;

    const optionElements = this.renderOptions(this.props);
    return <div className={className}>{optionElements}</div>;
  },
});

module.exports = ActiveSelect;



// WEBPACK FOOTER //
// ./src/component/mui/select/active-select.jsx